import quoteGQLString from '../../util/quoteGQLString';

export default (patent) => `
    id: ${quoteGQLString(patent?.id)}
    org: ${quoteGQLString(patent?.org)}
    patentLostDate: ${quoteGQLString(patent?.patentLostDate)}
    drugDescription: ${quoteGQLString(patent?.drugDescription)}
`;
